module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-card', {
    staticClass: "numberCard",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "bordered": "false"
    },
    nativeOn: {
      "click": function($event) {
        _vm.go()
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.cardname) + _vm._s(_vm.addMaohao(_vm.cardvalue)))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-bbef9fca"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/ValueCard.vue
// module id = 257
// module chunks = 2